<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout d'un type de {{ labelIntervention }}
	</span>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-5 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
			</div>
			<div class="row my-2">
				<form id="formEdit" [formGroup]="formEdit" (ngSubmit)="onSubmit()">
					<div class="row my-4">
						<label for="type" class="form-label theme-main-color fw-bold"
							>Type</label
						>
						<input
							autocomplete="off"
							placeholder="Saisissez un type de prestation"
							type="text"
							class="form-control"
							id="type"
							name="type"
							formControlName="type"
							[ngClass]="{
								'is-invalid': type.invalid,
								'is-valid': type.dirty && type.valid
							}"
						/>
						<div
							*ngIf="type.invalid && (type.dirty || type.touched)"
							class="text-danger"
						>
							<span *ngIf="type.errors?.required"> Un type est requis</span>
							<span *ngIf="type.errors?.pattern">
								Le type ne peut pas comporter de chiffre</span
							>
							<span *ngIf="type.errors?.maxLength"> Le type est trop long</span>
						</div>
					</div>

					<div class="row my-4">
						<label for="type" class="form-label theme-main-color fw-bold"
							>Nombre d'intervenants max</label
						>
						<input
							type="number"
							min="1"
							class="form-control"
							formControlName="numberOfEmployee"
							aria-label="Nombre d'intervenants"
						/>
					</div>

					<div class="row my-4" *ngIf="isFunderActive">
						<label for="inputFunder" class="form-label theme-main-color fw-bold"
							>Financeur</label
						>
						<input
							autocomplete="off"
							(keyup)="funderKeyUp($event.target)"
							formControlName="funder"
							[typeahead]="funders"
							typeaheadOptionField="name"
							[typeaheadMinLength]="0"
							placeholder="Saisissez un financeur"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadFunderOnSelect($event)"
						/>
					</div>

					<div class="row">
						<div [ngClass]="!isForExternalService.value ? 'col-4' : 'col-6'">
							<div class="form-check form-switch ms-3">
								<input
									class="form-check-input theme-main-border-color"
									type="checkbox"
									id="isForExternalService"
									formControlName="isForExternalService"
									[checked]="missionType.forExternalService"
									[ngClass]="{
										'theme-main-color-check': isForExternalService.value
									}"
									(change)="onExternalMissionTypeChange()"
								/>
								<label
									class="form-check-label text-dark"
									for="isForExternalService"
									>Mission externe</label
								>
							</div>
						</div>

						<div
							*ngIf="isForExternalService.value"
							[ngClass]="!isForExternalService.value ? 'col-4' : 'col-6'"
						>
							<div class="form-check form-switch ms-3">
								<input
									class="form-check-input theme-main-border-color"
									type="checkbox"
									id="isEmployeeExternal"
									formControlName="isEmployeeExternal"
									[checked]="missionType.employeeExternal"
									[ngClass]="{
										'theme-main-color-check': isEmployeeExternal.value
									}"
									(change)="onExternalMissionTypeChange()"
								/>
								<label
									class="form-check-label text-dark"
									for="isEmployeeExternal"
									>Nécessite intervenant interne</label
								>
							</div>
						</div>

						<div
							[ngClass]="!isForExternalService.value ? 'col-4' : 'col-6'"
							*ngIf="!isForExternalService.value"
						>
							<div class="form-check form-switch ms-3">
								<input
									class="form-check-input theme-main-border-color"
									type="checkbox"
									id="isAutoAssignment"
									formControlName="isAutoAssignment"
									[checked]="missionType.autoAssignment"
									[ngClass]="{
										'theme-main-color-check': isAutoAssignment.value
									}"
								/>
								<label class="form-check-label text-dark" for="isAutoAssignment"
									>Affectation par optimisation</label
								>
							</div>
						</div>
					</div>

					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								class="btn theme-main-color-button mx-3 px-3"
								type="button"
								(click)="bsModalRef.hide()"
							>
								Retour
							</button>
							<button
								[disabled]="!formEdit.valid || isValidateButtonClicked"
								class="btn theme-green-button"
								type="submit"
								form="formEdit"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i
								>Sauvegarder
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
